import React, { useState, useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Template from './template';
import { SmallMoveCarInfoRegister } from 'components';
import { PartnerAuthState } from 'stores/PartnerAuthStore';
import { ServiceState, ServiceAction } from 'stores/ServiceStore';
import { ServiceSmallMoveState } from 'stores/ServiceSmallMoveStore';
import { CarInfoState, CarInfoAction } from './store';
import { apiSmallMoveRegister } from 'api/ZimssaAPI';
import { SERVICE_SELECT } from 'router/PageUrl';
import { getBusinessLicenseWithHyphen, getTransportationLicenseWithHyphen, validateInput, validateLength } from 'commons/ZimssaHelper';
import ZimssaConstant from 'commons/ZimssaConstant';
import {
    SELECT_DEFAULT_CAR_TYPE,
    SELECT_DEFAULT_CAR_SIZE,
    SELECT_DEFAULT_CAR_LOCATION,
    SELECT_DEFAULT_CAR_NUMBER,
    PAGE_SERVICE_SMALLMOVE_REGISTER_TITLE,
    PLACEHOLDER_CAR_NUMBER,
    BUTTON_COMPLETE,
} from 'commons/ZimssaString';

function SmallMoveCarInfoRegisterView(): React.ReactElement {
    const history = useHistory();
    const [carLocation, setCarLocation] = useState<string>();
    const [carNumber1, setCarNumber1] = useState<string>();
    const [carNumber2, setCarNumber2] = useState<string>();
    const [carNumber3, setCarNumber3] = useState<string>();
    const { partnerIdx } = useContext(PartnerAuthState);
    const dispatcher = useContext(CarInfoAction);
    const serviceDispatcher = useContext(ServiceAction);

    const {
        serviceName,
        serviceImage,
        introduce,
        startYear,
        partnerServiceImages,
        businessRegistrationNumber,
        businessRegistrationImage,
        businessRegistrationOwner,
        taxClassification,
        familyRelationImage,
        location1,
        location2,
    } = useContext(ServiceState);

    const { transportationLicenseNumber, transportationLicenseImage } = useContext(ServiceSmallMoveState);
    const { size, type, etc, plateNumber, color, image } = useContext(CarInfoState);

    const onClickRegisterCallback = useCallback(() => {
        apiSmallMoveRegister({
            service: {
                serviceName: serviceName,
                serviceImage: serviceImage,
                introduce: introduce,
                startYear: startYear,
                partnerServiceImages: partnerServiceImages,
                businessRegistrationNumber: getBusinessLicenseWithHyphen(businessRegistrationNumber),
                businessRegistrationImage: businessRegistrationImage,
                businessRegistrationOwner: businessRegistrationOwner,
                taxClassification: taxClassification,
                familyRelationImage: familyRelationImage,
                location1: location1,
                location2: location2,
            },
            smallMove: {
                transportationLicenseNumber: getTransportationLicenseWithHyphen(transportationLicenseNumber),
                transportationLicenseImage: transportationLicenseImage,
            },
            carInfo: {
                size: size,
                type: type,
                etc: etc,
                plateNumber: plateNumber,
                color: color,
                image: image,
            },
        })
            .then((response) => {
                const { result, message } = response;
                if (result === 'success') {
                    alert('서류 제출을 완료 하였습니다.');
                    serviceDispatcher({
                        type: 'INIT_STATE',
                    });
                    history.push(SERVICE_SELECT.url);
                } else {
                    if (message) alert(message);
                }
            })
            .catch((error) => {});
    }, [
        serviceName,
        serviceImage,
        introduce,
        startYear,
        partnerServiceImages,
        businessRegistrationNumber,
        businessRegistrationImage,
        businessRegistrationOwner,
        taxClassification,
        familyRelationImage,
        location1,
        location2,
        transportationLicenseNumber,
        transportationLicenseImage,
        size,
        type,
        etc,
        plateNumber,
        color,
        image,
        history,
        serviceDispatcher,
    ]);

    const onChangeHandlerCallback = useCallback(
        (type: any, value: string) => {
            dispatcher({
                type,
                value: value,
            });
        },
        [dispatcher]
    );

    const smallMoveCarInfoRegisterProps = {
        image: {
            inputName: 'image',
            imgDir: ZimssaConstant.IMG_DIR.SERVICE.SMALLMOVE_CAR.replace('{{partnerIdx}}', `${partnerIdx}`),
            isDeleteBtn: true,
            onChangeHandler: onChangeHandlerCallback,
        },
        type: {
            inputName: 'type',
            children: [{ name: SELECT_DEFAULT_CAR_TYPE, value: '' }, ...ZimssaConstant.CAR_INFO.TYPE],
            onChangeHandler: onChangeHandlerCallback,
        },

        carLocation: {
            inputName: 'carLocation',
            children: [{ name: SELECT_DEFAULT_CAR_LOCATION, value: '' }, ...ZimssaConstant.CAR_INFO.LOCATION],
            onChangeHandler: (type: any, value: string) => {
                setCarLocation(value);
                dispatcher({
                    type: 'plateNumber',
                    value: `${value} ${carNumber1} ${carNumber2} ${carNumber3}`,
                });
            },
        },

        carNumber1: {
            inputName: 'carNumber1',
            placeholder: PLACEHOLDER_CAR_NUMBER,
            isValid: (() => {
                if (validateInput(carNumber1 || '')) {
                    if (validateLength(carNumber1 || '', 2) || validateLength(carNumber1 || '', 3)) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            })(),
            onChangeHandler: (type: any, value: string) => {
                setCarNumber1(value);
                dispatcher({
                    type: 'plateNumber',
                    value: `${carLocation} ${value} ${carNumber2} ${carNumber3}`,
                });
            },
        },

        carNumber2: {
            inputName: 'carNumber2',
            children: [{ name: SELECT_DEFAULT_CAR_NUMBER, value: '' }, ...ZimssaConstant.CAR_INFO.NUMBER_KR],
            onChangeHandler: (type: any, value: string) => {
                setCarNumber2(value);
                dispatcher({
                    type: 'plateNumber',
                    value: `${carLocation} ${carNumber1} ${value} ${carNumber3}`,
                });
            },
        },

        carNumber3: {
            inputName: 'carNumber3',
            placeholder: PLACEHOLDER_CAR_NUMBER,
            isValid: (() => {
                if (validateInput(carNumber3 || '')) {
                    if (validateLength(carNumber3 || '', 4)) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            })(),
            onChangeHandler: (type: any, value: string) => {
                setCarNumber3(value);
                dispatcher({
                    type: 'plateNumber',
                    value: `${carLocation} ${carNumber1} ${carNumber2} ${value}`,
                });
            },
        },

        size: {
            inputName: 'size',
            children: [{ name: SELECT_DEFAULT_CAR_SIZE, value: '' }, ...ZimssaConstant.CAR_INFO.SIZE_SMALL],
            onChangeHandler: onChangeHandlerCallback,
        },

        etc: {
            onChangeHandle: (value: string) => {
                dispatcher({
                    type: 'etc',
                    value,
                });
            },
        },
        color: {
            state: color,
            onClick: useCallback(
                (e: React.MouseEvent<HTMLDivElement, MouseEvent>, value?: any) => {
                    dispatcher({
                        type: 'color',
                        value,
                    });
                },
                [dispatcher]
            ),
        },
        btnNext: {
            contents: BUTTON_COMPLETE,
            isActive:
                carLocation &&
                validateInput(carNumber1 || '') &&
                (validateLength(carNumber1 || '', 2) || validateLength(carNumber1 || '', 3)) &&
                carNumber2 &&
                validateInput(carNumber3 || '') &&
                validateLength(carNumber3 || '', 4) &&
                type &&
                size &&
                color
                    ? true
                    : false,
            isComplete: false,
            onClick: onClickRegisterCallback,
        },
    };

    return (
        <Template title={PAGE_SERVICE_SMALLMOVE_REGISTER_TITLE}>
            <SmallMoveCarInfoRegister {...smallMoveCarInfoRegisterProps} />
        </Template>
    );
}

export default SmallMoveCarInfoRegisterView;
